// Regex que rejeita acentos e valida formato de email
// Aceita: letras, números, pontos, underscores, hífens e sinais de mais
// Caracteres especiais devem estar entre caracteres alfanuméricos
const EMAIL_REGEX = /^[a-zA-Z0-9]+([._+-][a-zA-Z0-9]+)*@[a-zA-Z0-9]+([.-][a-zA-Z0-9]+)*\.[a-zA-Z]{2,}$/;

export const isValidEmail = (email: string): boolean => {
  if (!email) return false;
  return EMAIL_REGEX.test(email);
};
